import { render, staticRenderFns } from "./TopBarV2.vue?vue&type=template&id=106e5b84&scoped=true"
import script from "./TopBarV2.vue?vue&type=script&lang=js"
export * from "./TopBarV2.vue?vue&type=script&lang=js"
import style0 from "./TopBarV2.vue?vue&type=style&index=0&id=106e5b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106e5b84",
  null
  
)

export default component.exports